<template>
    <Modal
        :prevent-scrolling="false"
        v-if="showLimitExceed"
        max-width="sm:max-w-4xl z-[9999]"
        @modal:close="handleClose()"
    >
        <template #body>
            <subscription-purchase-options
                v-if="isSubscriptionModelActivated()"
                @goback="handleGoBack"
                @selectedPackage="selectedPackage=true"
                :exceed-limit="true"
                :error-message-exceeded-limit="currentFeatureExceedMessage"
            />

            <purchase-options
                v-else
                @goback="handleGoBack"
                @selectedPackage="selectedPackage=true"
            />
        </template>
    </Modal>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';

import { update as updateProfile } from '../api/profile'
import { isSubscriptionModelActivated } from "../utils/helpers";
import { useFeatureUsageStore } from "../store/feature-usage.store";
import { useSubscriptionTrackerStore } from "../store/subscription-tracker.store";

import Modal from "../components/modal";
import PurchaseOptions from '../components/purchase-options';
import SubscriptionPurchaseOptions from "../components/subscription-purchase-options.vue";

const featuresUsageExceedStore = useFeatureUsageStore();
const subscriptionTrackerStore = useSubscriptionTrackerStore();
const selectedPackage = ref(false)
const {
    currentFeatureExceedMessage,
    showLimitExceed
} = storeToRefs(featuresUsageExceedStore)

const handleClose = async () => {
    await markIfPaymentCanceled()
    featuresUsageExceedStore.hideLimitExceed();
    subscriptionTrackerStore.handleCloseModal()
}

const handleGoBack = async () => {
    selectedPackage.value = true
    await markIfPaymentCanceled()
}

const markIfPaymentCanceled = async () => {
    if (selectedPackage.value) {
        return await updateProfile({
            options: {
                [`is_card_abandoned`]: true
            }
        })
    }
}
</script>
